import React, { FC, useMemo } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { htmlToPlainText } from "./htmlToPlainText";

interface ExpandedEducation {
  education: string;
}

const useStyles = makeStyles(() => ({
  education: {
    fontSize: 12,
    color: "#858997",
    wordBreak: "break-word",
    whiteSpace: "pre-wrap",
  },
}));

export const ExpandedEducation: FC<ExpandedEducation> = ({ education }) => {
  const classes = useStyles();
  const plainEducation = useMemo(() => htmlToPlainText(education), [education]);

  return <div className={classes.education}>{plainEducation}</div>;
};
